module.exports = __webpack_public_path__ + "static/media/gdax.3be6aa7d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/exchanges/gdax.svg
// module id = 101
// module chunks = 0